
// Robust default: match current host to avoid localhost/127.0.0.1 CORS mismatch
const hostBase = (() => {
  const { protocol, hostname } = window.location;
  // Prefer same host; assume FastAPI on :8000 unless overridden
  return `${protocol}//${hostname}:8000`;
})();

const API_BASE = process.env.REACT_APP_API_BASE_URL || hostBase;

function authHeaders() {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

async function get(path) {
  const url = `${API_BASE}${path}`;
  try {
    const res = await fetch(url, { headers: { "Content-Type": "application/json", ...authHeaders() } });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
  } catch (err) {
    console.error("GET failed", url, err);
    throw err;
  }
}

async function post(path, body) {
  const url = `${API_BASE}${path}`;
  try {
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", ...authHeaders() },
      body: JSON.stringify(body || {}),
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
  } catch (err) {
    console.error("POST failed", url, err);
    // Surface a clearer message for CORS / network issues
    if (err instanceof TypeError) {
      throw new Error("Network/CORS error. Verify API_BASE and server are reachable.");
    }
    throw err;
  }
}

export const HiveAPI = {
  currentMap: () => get("/hivemind/maps/current"),
  listMaps: () => get("/hivemind/maps"),
  getMoves: (mapId) => get(`/hivemind/maps/${mapId}/moves`),
  postMove: (mapId, payload) => post(`/hivemind/maps/${mapId}/moves`, payload),
  vote: (moveId, kind) => post(`/hivemind/moves/${moveId}/vote`, { kind }),
  participants: (mapId) => get(`/hivemind/maps/${mapId}/participants`),
  invite: (emails) => post(`/hivemind/invite`, { emails }),
};
